//@ts-nocheck
/**
 * LazyLoading for images
 * Docs : https://github.com/verlok/vanilla-lazyload
 */

const lazyLoad = () => {
  var myLazyLoad = new LazyLoad({ // eslint-disable-line no-undef
    // addtional config can be added below
  });
  myLazyLoad.update();
};

export default lazyLoad;
